import Image from '@/components/Image/Image';
import contentService from '@/services/contentService';
import type {IconModel} from '@/types/aem';
import {twx} from '@/utils/tailwindUtils';

type RemoteIconProps = {
    icon?: IconModel | null;
    className?: string;
};

const RemoteIcon = ({icon, className}: RemoteIconProps) => {
    const src = icon?.path ? contentService.getContentPath(icon.path) : undefined;

    if (!src) return null;

    return (
        <Image src={src} alt={icon?.alt ?? ''} aria-hidden={!icon?.alt} className={twx('object-contain', className)} />
    );
};

export default RemoteIcon;
